import { MatchWithTeams } from '../types/database';
import { MatchStatusService } from '../services/matchStatusService';

export interface UIMatch {
  id: string;
  name: string;
  date: string;
  time: string;
  tournament: {
    id: string;
    name: string;
    logo: string;
  };
  homeTeam: {
    name: string;
    logo: string;
    score: number;
  };
  awayTeam: {
    name: string;
    logo: string;
    score: number;
  };
  homePenaltyScore?: number;
  awayPenaltyScore?: number;
  isFavorite: boolean;
  venue: string;
  status: 'upcoming' | 'live' | 'finished';
}

export const transformMatchToUI = (match: MatchWithTeams): UIMatch => {
  // Use dynamic status calculation
  const statusCalculation = MatchStatusService.calculateMatchStatus(
    match.start_date, 
    match.end_date || undefined
  );
  
  // Map 'completed' to 'finished' for UI compatibility
  const uiStatus = statusCalculation.status === 'completed' ? 'finished' : statusCalculation.status;

  return {
    id: match.id,
    name: match.name,
    date: new Date(match.start_date).toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }),
    time: new Date(match.start_date).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    }),
    tournament: {
      id: match.tournament?.id || '',
      name: match.tournament?.name || 'League',
      logo: match.tournament?.logo || '⚽'
    },
    homeTeam: {
      name: match.home_team?.name || 'Unknown Team',
      logo: match.home_team?.logo || '🏟️',
      score: match.home_score || 0
    },
    awayTeam: {
      name: match.away_team?.name || 'Unknown Team',
      logo: match.away_team?.logo || '🏟️',
      score: match.away_score || 0
    },
    homePenaltyScore: match.home_penalty_score,
    awayPenaltyScore: match.away_penalty_score,
    isFavorite: false, // TODO: Implement favorites system
    venue: match.venue || 'TBD',
    status: uiStatus
  };
};
